import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { StatCard } from '../../components/shared/StatCard';
import { VerificationQueue } from '../../components/admin/VerificationQueue';
import { AnalyticsChart } from '../../components/admin/AnalyticsChart';
import { FraudDetection } from '../../components/ai/FraudDetection';
import { MOCK_VERIFICATIONS, MOCK_ANALYTICS } from '../../utils/mockData';
import { Users, ShieldCheck, AlertTriangle, TrendingUp, Activity } from 'lucide-react';
import { motion } from 'framer-motion';
export function AdminDashboard() {
  const pendingVerifications = MOCK_VERIFICATIONS.filter(v => v.status === 'pending');
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-2859">
      <Sidebar data-id="element-2860" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-2861">
        <DashboardHeader data-id="element-2862" />

        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-2863">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-2864">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 lg:mb-8 gap-4" data-id="element-2865">
              <div className="min-w-0" data-id="element-2866">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-2867">
                  Admin Overview
                </h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-2868">
                  Platform metrics and verification queue.
                </p>
              </div>
              <div className="flex gap-3 flex-shrink-0" data-id="element-2869">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 whitespace-nowrap" data-id="element-2870">
                  <Activity className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-2871" /> System
                  Healthy
                </span>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-2872">
              <StatCard title="Total Tenants" value="1,248" icon={Users} color="blue" trend={{
              value: 12,
              isPositive: true
            }} data-id="element-2873" />
              <StatCard title="Active Settlements" value="₦45.2M" icon={TrendingUp} color="green" trend={{
              value: 8,
              isPositive: true
            }} data-id="element-2874" />
              <StatCard title="Pending Verifications" value={pendingVerifications.length} icon={ShieldCheck} color="orange" data-id="element-2875" />
              <StatCard title="Risk Alerts" value="3" icon={AlertTriangle} color="purple" trend={{
              value: 2,
              isPositive: false
            }} data-id="element-2876" />
            </div>

            {/* AI Fraud Detection */}
            <div className="mb-6 lg:mb-8" data-id="element-2877">
              <FraudDetection data-id="element-2878" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 mb-6 lg:mb-8" data-id="element-2879">
              {/* Main Chart */}
              <div className="lg:col-span-2" data-id="element-2880">
                <AnalyticsChart title="Revenue Trends (6 Months)" type="area" data={MOCK_ANALYTICS.revenue} dataKey="amount" xAxisKey="month" color="#1D4ED8" height={320} data-id="element-2881" />
              </div>

              {/* Risk Distribution */}
              <div className="lg:col-span-1" data-id="element-2882">
                <AnalyticsChart title="Tenant Risk Distribution" type="pie" data={MOCK_ANALYTICS.riskDistribution} dataKey="value" height={320} data-id="element-2883" />
              </div>
            </div>

            {/* Verification Queue */}
            <section className="mb-6 lg:mb-8" data-id="element-2884">
              <VerificationQueue requests={pendingVerifications} onApprove={id => console.log('Approve', id)} onReject={id => console.log('Reject', id)} onView={id => console.log('View', id)} data-id="element-2885" />
            </section>
          </motion.div>
        </div>
      </main>
    </div>;
}